import { createSlice } from '@reduxjs/toolkit';

import {
    DELETE_ITEM,
    DELETE_ITEM_FAILURE,
    DELETE_ITEM_SUCCESS,
    FETCH_ITEM_DETAIL,
    FETCH_ITEM_DETAIL_FAILURE,
    FETCH_ITEM_DETAIL_SUCCESS,
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
    FETCH_POLITICAL_DIVISIONS1,
    FETCH_POLITICAL_DIVISIONS1_FAILURE,
    FETCH_POLITICAL_DIVISIONS1_SUCCESS,
    FETCH_POLITICAL_DIVISIONS2,
    FETCH_POLITICAL_DIVISIONS2_FAILURE,
    FETCH_POLITICAL_DIVISIONS2_SUCCESS,
    INITIALIZE_FORM,
    OPEN_PRODUCT_FORM,
    RESET,
    RESET_FORM,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_IS_NEW_RECORD,
    UPDATE_ITEMS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: { errors: null, isFetching: false },
    cities: { data: [], errors: [], isFetching: false },
    filters: { orderBy: '', page: 1, search: '', sortBy: '' },
    initialValues: { city: '', country: '', state: '', wind_speed: 0 },
    isNewRecord: false,
    isOpenProductForm: false,
    itemDetail: { data: null, errors: [], isFetching: false },
    items: {
        data: { data: [], paginaton: {} },
        error: null,
        isFetching: false,
    },
    productStatus: { data: {}, errors: null, isSaving: false },
    save: { data: {}, errors: null, isSaving: false },
    states: { data: [], errors: [], isFetching: false },
};

const slice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [DELETE_ITEM]: (state) => {
            state.deleteItem = {
                ...state.deleteItem,
                errors: [],
                isDeleting: true,
            };
        },
        [DELETE_ITEM_FAILURE]: (state, action) => {
            state.deleteItem = {
                ...state.deleteItem,
                errors: action.payload,
                isDeleting: false,
            };
        },
        [DELETE_ITEM_SUCCESS]: (state) => {
            state.deleteItem = {
                ...state.deleteItem,
                isDeleting: false,
            };
        },
        [FETCH_ITEMS]: (state) => {
            state.items = {
                ...state.items,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEMS_FAILURE]: (state, action) => {
            state.items = {
                ...state.items,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEMS_SUCCESS]: (state, action) => {
            state.items = {
                ...state.items,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM_DETAIL]: (state) => {
            state.itemDetail = {
                ...state.itemDetail,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEM_DETAIL_FAILURE]: (state, action) => {
            state.itemDetail = {
                ...state.itemDetail,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM_DETAIL_SUCCESS]: (state, action) => {
            state.itemDetail = {
                ...state.itemDetail,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_POLITICAL_DIVISIONS1]: (state) => {
            state.states = {
                ...state.states,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_POLITICAL_DIVISIONS1_FAILURE]: (state, action) => {
            state.states = {
                ...state.states,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_POLITICAL_DIVISIONS1_SUCCESS]: (state, action) => {
            state.states = {
                ...state.states,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_POLITICAL_DIVISIONS2]: (state) => {
            state.cities = {
                ...state.cities,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_POLITICAL_DIVISIONS2_FAILURE]: (state, action) => {
            state.cities = {
                ...state.cities,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_POLITICAL_DIVISIONS2_SUCCESS]: (state, action) => {
            state.cities = {
                ...state.cities,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [OPEN_PRODUCT_FORM]: (state, action) => {
            state.isOpenProductForm = action.payload;
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE]: (state) => {
            state.save = { ...state.save, errors: [], isSaving: true };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state) => {
            state.save = {
                ...state.save,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.items.data.data = action.payload;
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;
